import { Command } from '../../config/commands'
import './CommandItem.css'

interface CommandItemProps {
  command: Command
  isSelected: boolean
  onClick: () => void
  onMouseEnter: () => void
}

/**
 * Individual command item in the command palette
 */
export function CommandItem({
  command,
  isSelected,
  onClick,
  onMouseEnter,
}: CommandItemProps) {
  return (
    <li
      role="option"
      aria-selected={isSelected}
      data-command-id={command.id}
      className={`command-item ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
    >
      <div className="command-item-content">
        {command.icon && (
          <span className="command-item-icon" aria-hidden="true">
            {command.icon}
          </span>
        )}

        <div className="command-item-text">
          <div className="command-item-label">{command.label}</div>
          {command.description && (
            <div className="command-item-description">{command.description}</div>
          )}
        </div>

        {command.shortcut && (
          <div className="command-item-shortcut">
            <kbd>{command.shortcut}</kbd>
          </div>
        )}
      </div>
    </li>
  )
}
